import { h } from "preact";

import { classNames, countryCodeToFlagUrl } from "../helpers";

export default function CountryFlag({ code, ...props }) {
  return (
    <span
      {...props}
      class={classNames("passpartout passpartout-24", props.class)}
    >
      <img src={countryCodeToFlagUrl(code)} />
    </span>
  );
}
